import axios from "axios";
import { baseUrl } from "../Base_url";
export const getSchoolByDistrictAdmin = async (token) => {
    try {
        const res = await axios.get(`${baseUrl}/district-admin/school-district/school/all`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return { error: false, res: res };
    } catch (e) {
        const err = { error: true, data: e?.response?.data?.data };
        return err;
    }
}
export const getAllSchoolTeachers = async (sid, token) => {
    try {
        const res = await axios.post(`${baseUrl}/getTeacherBySchoolId`, { id: sid }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return { error: false, res: res };
    } catch (e) {
        const err = { error: true, data: e?.response?.data?.data };
        return err;
    }
}
export const createNewLaunchTrek = async (data, token) => {
    try {
      const res = await axios.post(`${baseUrl}/district-admin/launchtrek/createLaunchTrek`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e?.response?.data?.data };
      return err;
    }
  };
  export const getLaunchTrekData = async (token,page,limit,orderBy,order) => {
    try {
      const res = await axios.get(`${baseUrl}/district-admin/launchtrek/getLauchtrekFiles`, {
        params: { page: page, limit:limit,orderBy:orderBy,order:order },
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      return e;
    }
  };
  export const getFileDetails = async (id, token) => {
    try {
      const res = await axios.get(`${baseUrl}/district-admin/launchtrek/getLauchtrekFilesById`, {
        params: { id: id },
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      return e;
    }
  };
  export const getGraphDetails = async (id, token) => {
    try {
      const res = await axios.get(`${baseUrl}/district-admin/launchtrek/getGraphByfileId`, {
        params: { id: id },
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      return e;
    }
  };
  export const updateLaunchtrekFile = async (id, data, token) => {
    try {
     
      const res = await axios.patch(`${baseUrl}/district-admin/launchtrek/editFileData`, data, {
        params: { id: id },
        headers: { Authorization: `Bearer ${token}` },
      });
    
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e?.response?.data?.data };
      return err;
    }
  };
  
  export const deleteLaunchTrekFile = async (id, token) => {
    try {
      const res = await axios.delete(`${baseUrl}/district-admin/launchtrek/deleteLaunchFiles`, {
        params: { id: id },
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e?.response?.data?.data };
      return err;
    }
  };
   